import React, { Fragment } from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, bool, shape, object, number,
} from 'prop-types'

import SearchSubscription from 'Pods/SearchSubscription/SearchSubscription'
import i18n from 'Pods/Shared/I18n'

import countActiveFilters from 'Utils/countActiveFilters'
import { EMPTY_OBJECT } from 'Utils/stableDefaults'

import WithListingPageContext from '../WithListingPageContext'
import CategoryBanner from './Components/CategoryBanner'
import Hire3dFreelancerBanner from './Components/Hire3dFreelancerBanner'
import LinksToTags from './Components/LinksToTags'

function FooterBanners({
  browserAttributes = EMPTY_OBJECT,
  extractingCoreStyles,
  selectedFilters,
  currentUserId = null,
  tagLinks = EMPTY_OBJECT,
  pageCategory = '',
  locale = 'en',
}) {
  const hasSelectedAnySuggestion = !!selectedFilters.suggested_keywords
  const activeFilterCount = Object.values(
    countActiveFilters(selectedFilters)
  ).reduce((acc, value) => acc + Number(value), 0)

  const isBottomBannerVisible = (
    !hasSelectedAnySuggestion
    && activeFilterCount < 1
    && !currentUserId
    && browserAttributes
    && browserAttributes?.bottomDescription
    && browserAttributes?.title
    && browserAttributes?.description
  )

  const keywords = selectedFilters.keywords || pageCategory || ''
  const pricing = selectedFilters.pricing || {}
  const showSearchSubscription = !!keywords && !pricing.free

  const title = i18n.t('listingPage.footerBanners.title', { ns: 'rails', lng: locale })

  return (
    <div className="container-fluid">
      <div className="footer-banners">
        <div className="cgt-legacy-heading-h4 cgt-legacy-text--align-center footer-banners__title">
          {title}
        </div>

        <div
          className={`footer-banners__items cgt-mb-20${
            !showSearchSubscription ? ' footer-banners__items--single' : ''
          }`}
        >
          {showSearchSubscription && (
            <SearchSubscription keywords={keywords} pricing={pricing} />
          )}
          <Hire3dFreelancerBanner locale={locale} />
        </div>

        <LinksToTags tagLinks={tagLinks} />

        {(extractingCoreStyles || isBottomBannerVisible) && (
          <Fragment>
            <Divider customClass="footer-banners__divider" />
            <div className="footer-banners__category">
              {extractingCoreStyles && (
                <CategoryBanner
                  title="title"
                  description="description"
                  isLoading
                />
              )}
              {isBottomBannerVisible && (
                <CategoryBanner
                  title={browserAttributes.title}
                  description={browserAttributes.description}
                />
              )}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  )
}

FooterBanners.propTypes = {
  browserAttributes: shape({
    bottomDescription: bool,
    description: string,
    title: string,
  }),
  extractingCoreStyles: bool.isRequired,
  selectedFilters: object.isRequired,
  currentUserId: number,
  tagLinks: shape({
    header: string,
    links: object,
  }),
  pageCategory: string,
  locale: string,
}

function mapStateToProps({ browserAttributes, selectedFilters, pageCategory, locale }) {
  return {
    browserAttributes,
    selectedFilters,
    pageCategory,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(FooterBanners)
